import OutlinedInput from '@material-ui/core/OutlinedInput';
import InputLabel from '@material-ui/core/InputLabel';
import MenuItem from '@material-ui/core/MenuItem';
import FormControl from '@material-ui/core/FormControl';
import ListItemText from '@material-ui/core/ListItemText';
import Select from '@material-ui/core/Select';
import Checkbox from '@material-ui/core/Checkbox';
import { FC } from 'react';
import PropTypes from 'prop-types';
import { FilterOption } from 'src/types/filter';

const ITEM_HEIGHT = 100;
const ITEM_PADDING_TOP = 1;

export interface MultiSelectDropDownProps {
  label: string;
  index: string;
  disabled?: boolean;
  mlRequierd?: boolean
  options: Array<FilterOption>;
  selectedOptions: Array<string>;
  onSelect: (event: any) => void;
}

export const MultiSelectDropDown: FC<MultiSelectDropDownProps> = (props) => {
  const {
    label: boxLabel,
    index,
    options,
    disabled,
    selectedOptions,
    mlRequierd,
    onSelect } = props;

  return (
    <FormControl
      size="small"
      sx={{ m: 1, ml: mlRequierd ? 1 : 0, width: '100%' }}
    >
      <InputLabel>{boxLabel}</InputLabel>
      <Select
        multiple
        value={selectedOptions || []}
        name={index}
        disabled={disabled}
        onChange={onSelect}
        input={<OutlinedInput label={boxLabel} />}
        renderValue={(selected) => selected.join(', ')}
        MenuProps={{
          anchorOrigin: {
            vertical: 'bottom',
            horizontal: 'right',
          },
          PaperProps: {
            style: {
              maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
              // width: 120,
            },
          },
        }}
      >
        {options?.map((opt) => (
          <MenuItem
            key={opt.id}
            value={opt.id ? opt.id.toString().concat(' ') : undefined}
          >
            <Checkbox checked={selectedOptions.indexOf(opt.value) > -1} />
            <ListItemText primary={opt.id ? opt.value : 'None'} />
          </MenuItem>
        ))}
      </Select>
    </FormControl>
  );
};

MultiSelectDropDown.propTypes = {
  label: PropTypes.string,
  index: PropTypes.string,
  disabled: PropTypes.bool,
  options: PropTypes.array,
  selectedOptions: PropTypes.array,
  mlRequierd: PropTypes.bool,
  onSelect: PropTypes.func,
};
